module.exports = __webpack_public_path__ + "img/item10.2ee25a54.png";